// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__32Z8H","rowLegend":"rowLegend__C5ms_","innerLegend":"innerLegend__1Igj1","row":"row__2z0YC","rowWrapper":"rowWrapper__3pAJu","rowWrapperItem":"rowWrapperItem__3lHd4","rowText":"rowText__3WB_V","country_percentage":"country_percentage__19Tmk","countryWrapper":"countryWrapper__P6LGH","allDonorWrapper":"allDonorWrapper__34mCZ","labelText":"labelText__385Vj","barValue":"barValue__10UpB","text":"text__2WqNp","barType":"barType__Tducy","imageWrapper":"imageWrapper__1GaFI","sdg_image":"sdg_image__uHBJJ"};


//////////////////
// WEBPACK FOOTER
// ./components/projectDonutBarChart/donutBarChart/components/barChartItem/style.scss
// module id = ygBH
// module chunks = 0 2